export default __webpack_public_path__ + "static/launchpad-dropdown-image-aa3ef6110c6c814036bff48bd467eb3c.png";